import { render, staticRenderFns } from "./textonly.vue?vue&type=template&id=e4c96a30&"
import script from "./textonly.vue?vue&type=script&lang=js&"
export * from "./textonly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports